export const SET_AND_FORGET_PROMO_MIN_MANUAL_CONSENT_ACTIVATIONS = 10;
